import React, { useEffect, useState } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";
import { ApolloError } from "apollo-boost";
import { Field, FieldProps, Form, Formik } from "formik";
import CircularProgress from "@material-ui/core/CircularProgress";
import LaunchIcon from '@material-ui/icons/Launch';
import * as Yup from "yup";

import styles from './index.module.css';
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";

import { Button, Checkbox, CheckboxProps, FormControl, FormControlLabel, Grid, IconButton, InputLabel, makeStyles, MenuItem, Paper, Radio, RadioGroup, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@material-ui/core';

import { useSelector } from 'react-redux';
import { isValidPhoneNumber } from "react-phone-number-input";
import Hidden from '@material-ui/core/Hidden';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import { IDriverRow } from "./AddNewDriver";
import DeleteIcon from '@material-ui/icons/Delete';
import { BookingType, IAddress, IAddressLocation, IBookingCreateInput, IBookingQuestionInput, ICustomerInfoInput, IDriverAvailableSlot, IGeoLocation } from "../../../../../../reducers/bookings/types";
import { useSnackBar } from "../../../../../SnackBarContext/SnackBarContext";
import { IAppState } from "../../../../../../store";
import { CREATE_CUSTOMER } from "../../../../../../graphql/customers/createCustomerMutation";
import { SnackBarVariant } from "../../../../../SnackbarWrapper/SnackbarWrapper";
import { formatGraphQLErrorMessage } from "../../../../../utils";
import { AccountType } from "../../../../../../reducers/auth/types";
import { getLocalizedAuthorisedSignatorySyntex, getLocalizedBookingSyntex } from "../../../../../../utils/localized.syntex";
import { SearchForm } from "../../../../CustomerPortal/SearchForm";
import { ANSWER_TYPES, BOOKING_CATEGORY, IBookingQuestion } from "../../../../../../reducers/website/types";
import AddressPicker from "../../../../../AddressPicker/AddressPicker";
import { bookingCategories, getMergedPreBookingQuestions } from "../../../utils";
import { GET_DRIVER_AVAILABLE_SLOTS } from "../../../../../../graphql/addOns/getValetAddOn";
import { DateTime as d, DateTime } from 'luxon';
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { IDriverAvailabilitySlot, IDriverSlot, ISlot, ISloteData, IValetSlotData } from "../../../SelectAddOns/types";

const WhiteCircularProgress = withStyles(() =>
  createStyles({
    root: {
      color: '#fff !important',
      width: 30,
      height: 30
    },
  }),
)(CircularProgress);

const useStyles = makeStyles((theme: Theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200,
    fontWeight: 600,

  },
}));

interface IProps {
  updateCustomer: (data: { customer?: string, businessCustomer?: string, approvedDrivers?: string[], preBookingQuestions?: IBookingQuestionInput[], customerNote?: string, costCenter?: string, projectId?: string, deliveryAddress?: IAddressLocation, valetSlot: IValetSlotData }) => void;
  onSubmit: (data: IBookingCreateInput) => void;
  customerInfo: ICustomerInfoInput;
  branchId?: string;
  bookingData: IBookingCreateInput;
  setBookingData: React.Dispatch<React.SetStateAction<IBookingCreateInput>>;
  driverCount?: number;
  updateBookingDrivers: (data: IDriverRow[]) => void;
  bookingDrivers?: IDriverRow[];
  isLastStepPersonalDetails: boolean
}
const StyledInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      // marginBottom: 20,
      '& .MuiOutlinedInput-input': {
        padding: '14px 14px'
      },
      '& .MuiOutlinedInput-multiline': {
        padding: '0px 4px'
      },
      '& .MuiOutlinedInput-root fieldset': {
        borderColor: '#e2e2e2',
        borderRadius: 8
      },
      '& .MuiSelect-select:focus': {
        backgroundColor: 'transparent'
      },
      '& .MuiSelect-select': {
        padding: '10px 14px'
      },
      '& .MuiSelect-select ~ fieldset': {
        border: 0
      },
    },
  }),
)(TextField);

const ColoredCheckbox = withStyles({
  root: {
    color: 'var(--primary-color)',
    '&$checked': {
      color: 'var(--primary-color)',
    },
  },
  checked: {},
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);

export interface IAdditionalDriver {
  id?: string;
  firstName: string;
  lastName: string;
  email: string;
  license: {
    authority: string;
    licenseNumber: string;
    dateOfExpiry: string;
    images: (string | object | undefined)[];
  };
  phoneNumber: {
    phone: string;
    country: string;
  };
  location: IAddress;
}

const SimpleCustomerView: React.FC<IProps> = (props) => {
  const classes = useStyles();
  const snackbar = useSnackBar();
  const website = useSelector((state: IAppState) => state.consumerWebsiteReducer.consumerWebsite);
  const currentBranchLocations = website.branches.find(branch => branch.id === props.bookingData.branchId)?.locations
  const { country } = website.organisation.address;
  const user = useSelector((state: IAppState) => state.authReducer.user);
  const authState = useSelector((state: IAppState) => state.authReducer)
  const branchData = useSelector((state: IAppState) => state.consumerWebsiteReducer.consumerWebsite.branches);
  const [driverCount, setDriverCount] = useState<number>(0);
  const [additionalDriverQuantity, setAdditionalDriverQuantity] = useState<number>(0);
  const [updateInProgress, setUpdateInProgress] = useState<boolean>(false);
  const [costCenter, setCostCenter] = useState<string>();
  const [projectId, setProjectId] = useState<string>();
  const [availableProjectIds, setAvailableProjectIds] = useState<string[]>([]);
  const [driverList, setDriverList] = useState<any[]>([]);
  const [selectedDriver, setSelectedDriver] = useState<IDriverRow | null>(null);
  const { t } = useTranslation();
  const [createCustomer, { loading: creatingCustomer }] = useMutation(CREATE_CUSTOMER, {

  });

  const isSubscriptionBooking: boolean = props.bookingData?.isSubscription || false

  const [availableDriverSlots, setAvailableDriverSlots] = useState<IDriverAvailabilitySlot[]>([])
  const [selectedDeliverySlot, setSelectedDeliverySlot] = useState<IDriverAvailabilitySlot>();
  const [selectedDriverId, setSelectedDriverId] = useState<string>("")
  const [enableDeliveryAddress, setEnableDeliveryAddress] = useState<boolean>(false)
  const logisticsEnabled = useSelector((state: IAppState) => state.consumerWebsiteReducer.consumerWebsite.tenancy.logisticsEnabled);
  const [valetSlot, setValetSlot] = useState<{ deliverySlot?: ISloteData, collectionSlot?: ISloteData }>({})

  const [getAvailableDriverSlots, { data: availableDriverSlotsData }] = useLazyQuery(GET_DRIVER_AVAILABLE_SLOTS, {
    fetchPolicy: "network-only",
    onCompleted: ({ consumerGetAvailableDriverSlots }) => {
      setAvailableDriverSlots(consumerGetAvailableDriverSlots?.slots ?? [])
    },
    onError: (error: ApolloError) => {
      console.error("Error fetching driver slots:", error)
    },
  })

  // useEffect(() => {
  //   if (user?.customer && user.customer.costCenters && costCenter) {
  //     setAvailableProjectIds(user.customer.costCenters?.find(cc => cc.name === costCenter)?.projectIds || [])
  //   }
  // }, [costCenter, user])
  
  const onSubmit = (values: ICustomerInfoInput) => {
    if (enableDeliveryAddress && !values.deliveryAddress?.fullAddress) {
      return snackbar({
        message: t("snackBar:provideDeliveryAddress"),
        variant: SnackBarVariant.ERROR
      })
    }
    // if (website.organisation.enableCostCenter && user?.customer && !costCenter) {
    //   return snackbar({
    //     message: t("snackBar:costCenterInfoMissing"),
    //     variant: SnackBarVariant.ERROR
    //   })
    // }
    const driversId = driverList.map(driver => driver.id)
    const {
      agreeToTerms: _agreeToTerms,
      preBookingQuestions: _preBookingQuestions,
      customerNote,
      deliveryAddress: _deliveryAddress,
      ...newCustomer
    } = values;
    const preBookingQuestions = values.preBookingQuestions.map((bq) => {
      return {
        question: bq.question,
        answerType: bq.answerType,
        answer: bq.answer?.toString() || ''
      }
    })

    if (user && user.customerId) {
      props.updateCustomer({ customer: user.customerId, approvedDrivers: driversId, preBookingQuestions, customerNote, costCenter, projectId, deliveryAddress: values.deliveryAddress, valetSlot: valetSlot });
    } else if (user && user.businesscustomers) {
      props.updateCustomer({ businessCustomer: user.businesscustomers.id, approvedDrivers: driversId, preBookingQuestions, customerNote, deliveryAddress: values.deliveryAddress, valetSlot: valetSlot });
    }
    else {
      createCustomer({
        variables: { customer: newCustomer }
      })
        .then((result: any) => {
          const { data } = result
          if (data && data.consumerCreateCustomer) {
            const driverArr: string[] = [];
            if (data.consumerCreateCustomer.approvedDrivers) {
              data.consumerCreateCustomer.approvedDrivers.forEach((driver: any) => {
                driverArr.push(driver.id);
              });
            }
            props.updateCustomer({ customer: data.consumerCreateCustomer.id, preBookingQuestions, customerNote, valetSlot });
            return
          }
        })
        .catch((error: ApolloError) => {
          snackbar({
            message: formatGraphQLErrorMessage(error.message),
            variant: SnackBarVariant.ERROR
          })
        });
    }
  };

  const customerSchema = Yup.object().shape({
    email: Yup.string()
      .required(t("validation:emailIsRequired"))
      .email(),
    firstName: Yup.string().required(t("validation:firstNameRequired")),
    lastName: Yup.string().required(t("validation:lastNameRequired")),
    phoneNumber: Yup.object().shape({
      phone: Yup.string()
        .required(t("validation:phoneNumberRequired"))
        .test('phone test', 'Invalid phone Number', (value) => {
          if (value) {
            let tempValue: string = value || '';
            return isValidPhoneNumber(tempValue);
          }
          return true;
        }),
    }),
    agreeToTerms: Yup.boolean()
      .required(t("validation:termsConditionsAccepted"))
      .oneOf([true], (t("validation:termsConditionsAccepted"))),
  });

  const validateAnswer = (value: any, required: boolean, expected?: string) => {
    let error;
    if (required) {
      if (expected === "TRUE" && !value) {
        error = "Error"
      }
      if (expected === "FALSE" && value) {
        error = "Error"
      }
      if (expected === "TEXT" && !value) {
        error = "Error"
      }
      if (expected === "YES" && value !== "YES") {
        error = "Error"
      }
      if (expected === "NO" && value !== "NO") {
        error = "Error"
      }
    }
    return error;
  }

  let mergedPreBookingQuestions: IBookingQuestion[] = []
  let preBookingQuestionsFromBranch: IBookingQuestion[] = [];
  const branch = branchData.find(branch => branch.id === props.branchId);
  if (branch) {
    branch.preBookingQuestions && branch.preBookingQuestions?.length && branch.preBookingQuestions.forEach((bq, idx) => {
      preBookingQuestionsFromBranch.push({
        ...bq,
        answer: ""
      });
    })
  }

  let preBookingQuestionsFromBooking: IBookingQuestionInput[] = []
  if (props.customerInfo && props.customerInfo.preBookingQuestions) {
    preBookingQuestionsFromBooking = props.customerInfo.preBookingQuestions
  }
  mergedPreBookingQuestions = getMergedPreBookingQuestions(preBookingQuestionsFromBooking, preBookingQuestionsFromBranch)

  useEffect(() => {
    if (props.bookingData && props.bookingData.addonRequirements) {
      const addon = props.bookingData.addonRequirements.find((item: any) => item.name === "ADDITIONAL_DRIVER");
      if (addon) {
        setAdditionalDriverQuantity(addon.quantity);
      }
    }
  }, [props.bookingData?.addonRequirements]);

  useEffect(() => {
    if (props.bookingData?.deliveryAddress?.fullAddress) {
      setEnableDeliveryAddress(true)
      const currentServiceLocation = currentBranchLocations?.find(
        (location) => location.id === props.bookingData.pickupServiceLocation
      );
      setSelectedDeliverySlot({
        startTime: props.bookingData?.valetSlot?.deliverySlot?.slot || "",
        endTime: "",
        driverId: props.bookingData?.valetSlot?.deliverySlot?.driverId || "",
      })
      setValetSlot({
        deliverySlot: {
          driverId: props.bookingData?.valetSlot?.deliverySlot?.driverId || "",
          slot: props.bookingData?.valetSlot?.deliverySlot?.slot || ""
        }
      })
      getAvailableDriverSlots({
        variables: {
          driverAvailableSlotArgs: {
            bookingCategory: props.bookingData?.isSubscription ? BOOKING_CATEGORY.SUBSCRIPTION : props.bookingData.bookingCategory,
            jobDate: props.bookingData.pickupDateTime,
            pickupCoordinate: {
              lat: currentServiceLocation?.address?.geometry?.latitude,
              lng: currentServiceLocation?.address?.geometry?.longitude,
            },
            dropOffCoordinate: {
              lat: props.bookingData?.deliveryAddress?.location?.latitude,
              lng: props.bookingData?.deliveryAddress?.location?.longitude,
            },
          },
          branchId: props.bookingData ? props.bookingData.branchId : "",
        },
      })
    }
  }, [props.bookingData?.deliveryAddress, props.bookingData.pickupOtherLocation])

  useEffect(() => {
    if (props.bookingDrivers?.length) {
      setDriverList(props.bookingDrivers)
      setDriverCount(props.bookingDrivers.length)
    }
  }, [props.bookingDrivers])

  const addExistingDriver = (data: IDriverRow) => {
    const existingDriver = driverList.some((driver) => driver.email === data.email)
    if (existingDriver) {
      return snackbar({
        message: t("snackBar:selectedDriverAlreadyAdded"),
        variant: SnackBarVariant.ERROR
      });
    } else {
      if (data) {
        if (driverCount < additionalDriverQuantity) {
          const driverData: any[] = [...driverList, data];
          setDriverList(driverData)
          setDriverCount((prevCount) => prevCount + 1);
          props.updateBookingDrivers(driverData)
          snackbar({
            message: t("snackBar:driverSavedSuccessfully"),
            variant: SnackBarVariant.SUCCESS
          })
        } else {
          snackbar({
            message: t("snackBar:additionalDriverCannotBeMore"),
            variant: SnackBarVariant.ERROR
          });
        }
      }
    }
  }

  const handleRemoveDriver = (newDriver: IDriverRow) => {
    const filteredDrivers = driverList.filter((driver) => driver.email !== newDriver.email)
    setDriverList(filteredDrivers)
    setDriverCount((prevCount) => prevCount - 1);
    props.updateBookingDrivers(filteredDrivers)
  }

  const getUniqueSortedSlots = (data: IDriverSlot[]): ISlot[] => {
    const parseTime = (timeStr: string): DateTime =>
      d.fromFormat(timeStr.trim().toUpperCase(), 'hh:mm a');

    const formatTime = (dt: DateTime): string =>
      dt.toFormat('hh:mm a');

    const slotMap = new Map<number, ISlot>();

    data.forEach(driver => {
      driver.slots.forEach(slot => {
        const startDt = parseTime(slot.startTime);
        const key = startDt.hour * 60 + startDt.minute;

        if (!slotMap.has(key)) {
          const endDt = parseTime(slot.endTime);
          slotMap.set(key, {
            startTime: formatTime(startDt),
            endTime: formatTime(endDt),
          });
        }
      });
    });

    return Array.from(slotMap.entries())
      .sort(([a], [b]) => a - b)
      .map(([_, slot]) => slot);
  };

  const getRandomDriverForSlot = (
    data: IDriverSlot[],
    selectedSlot: ISlot
  ): IDriverSlot | undefined => {
    const parseTime = (timeStr: string): DateTime =>
      d.fromFormat(timeStr.trim().toUpperCase(), 'hh:mm a');

    const targetStart = parseTime(selectedSlot.startTime);

    const matchingDrivers = data.filter(driver =>
      driver.slots.some(slot =>
        parseTime(slot.startTime).equals(targetStart)
      )
    );

    if (matchingDrivers.length === 0) return undefined;

    const randomIndex = Math.floor(Math.random() * matchingDrivers.length);
    return matchingDrivers[randomIndex];
  };

  const isSlotDisabled = (slot: ISlot, pickupDateTime: string): boolean => {
    if (!pickupDateTime) return false;
  
    const pickup = d.fromISO(pickupDateTime);
    const slotTime = d.fromFormat(slot.startTime.trim().toUpperCase(), "hh:mm a").set({
      year: pickup.year,
      month: pickup.month,
      day: pickup.day,
    });
  
    if (slotTime < pickup) return true;
  
    return false;
  };

  const handleSlotSelection = (slotData: IDriverAvailabilitySlot, type: "delivery" | "collection") => {
    const timeSlot = slotData.startTime
    if (type === "delivery") {
      setSelectedDeliverySlot(slotData)
      setSelectedDriverId(slotData.driverId || "");
      setValetSlot({
        deliverySlot: {
          driverId: slotData.driverId || "",
          slot: timeSlot
        }
      })
    }
  }

  return (
    <Formik
      validationSchema={!user?.id && customerSchema}
      initialValues={{
        ...props.customerInfo,
        agreeToTerms: false,
        preBookingQuestions: getMergedPreBookingQuestions(preBookingQuestionsFromBooking, preBookingQuestionsFromBranch),
        deliveryAddress: props.bookingData?.deliveryAddress ? props.bookingData.deliveryAddress : {
          city: "",
          country: "",
          fullAddress: "",
          state: "",
          street: "",
          zipcode: ""
        }
      }}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit(values);
        setSubmitting(false);
      }}
    >
      {(formikProps) => (
        <Form className={styles.container}>
          <Grid container>
            <Grid item container xs={12}>
              {(user && user.id) &&
                <Grid item xs={12}>
                  <Typography variant="body1" className="padding-bottom text-center semi-bold">{getLocalizedBookingSyntex(country)} {t("root:for")}</Typography>
                  {authState.accountType === AccountType.INDIVIDUAL ? <div className={styles.box}>
                    <div className={styles.avatar}>
                      <span className="font-large bold">{user.firstName.slice(0, 1).toUpperCase()}{user.lastName.slice(0, 1).toUpperCase()}</span>
                      {/* <img src="https://picsum.photos/200/200/?blur=10" /> */}
                    </div>
                    <div className="flex fill col-flex margin-left">
                      <Typography variant="h3" className="semi-bold" style={{ marginLeft: 1, marginBottom: 4 }}>{user.firstName} {user.lastName}</Typography>
                      <span className="flex cross-center font-medium opacity50" style={{ flexWrap: 'wrap' }}>
                        <span className="flex cross-center" style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
                          <EmailIcon style={{ fontSize: 17, marginRight: 3 }} />
                          <span>{user.email}</span>
                        </span>
                        <span className="flex cross-center" style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
                          <PhoneIcon style={{ fontSize: 17, marginRight: 3, marginLeft: 10 }} />
                          <span className="">{user.customer?.phoneNumber.phone}</span>
                        </span>
                      </span>
                    </div>
                  </div> :
                    <>
                      <div className={styles.box}>
                        <div className="flex fill col-flex">
                          <Typography variant="h3" className="semi-bold">{user.businesscustomers?.businessName || ""}</Typography>
                          <Typography variant="body1" className="opacity50" style={{ marginBottom: 15 }}>{t("root:businessAccount")}</Typography>
                          <span className="flex cross-center font-medium opacity50" style={{ flexWrap: 'wrap' }}>
                            <span className="margin-right">{t("root:contact")}: {user.firstName} {user.lastName}</span>
                            <span className="flex cross-center" style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
                              <EmailIcon style={{ fontSize: 17, marginRight: 3 }} />
                              <span>{user.email}</span>
                            </span>
                            <span className="flex cross-center" style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
                              <PhoneIcon style={{ fontSize: 17, marginRight: 3 }} />
                              <span className="">{user.phoneNumber.phone}</span>
                            </span>
                          </span>
                        </div>
                      </div>
                      {user?.businesscustomers &&
                        <Grid container xs={12} >
                          <Grid item xs={9}>
                            <FormControl variant="outlined" className={classes.formControl}>
                              <InputLabel id="demo-simple-select-outlined-label">{getLocalizedAuthorisedSignatorySyntex(country)} *</InputLabel>
                              <Select
                                required
                                labelId="demo-simple-select-outlined-label"
                                id="demo-simple-select-outlined"
                                value={props.bookingData.authorizedSignatory}
                                onChange={(event: any) => {
                                  const authorisedSignatory = event.target.value
                                  props.setBookingData({
                                    ...props.bookingData,
                                    authorizedSignatory: authorisedSignatory
                                  });
                                }}
                                label={getLocalizedAuthorisedSignatorySyntex(country)}
                              >
                                {user?.businesscustomers?.authorizedSignatories.map((ele, idx) => {
                                  return (
                                    <MenuItem value={ele.id}>
                                      {`${ele.firstName} ${ele.lastName}`}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>
                      }
                    </>}
                </Grid>
              }
            </Grid>
            <Grid item container xs={12}>
              {(user && (user?.customer || user.businesscustomers) && additionalDriverQuantity) ? (
                <Grid item container>
                  <Grid xs={6}>
                    <SearchForm
                      updateData={addExistingDriver}
                      dataOptions={user.customer?.approvedDrivers ? user.customer?.approvedDrivers : user?.businesscustomers?.approvedDrivers}
                    />
                  </Grid>
                </Grid>
              ) : <></>}
              {(user?.businesscustomers || user?.customer?.id) && driverList?.length ? (
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>{t("root:name")}</TableCell>
                        <TableCell>{t("root:email")}</TableCell>
                        <TableCell style={{ textAlign: 'center' }}>{t("root:action")}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {driverList.map((driver: IDriverRow, index: number) => (
                        <TableRow key={index}>
                          <TableCell>{`${driver.firstName} ${driver.lastName}`}</TableCell>
                          <TableCell>{driver.email}</TableCell>
                          <TableCell style={{ textAlign: 'center' }}>
                            <IconButton
                              color="secondary"
                              aria-label="delete"
                              onClick={() => handleRemoveDriver(driver)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : <></>}
            </Grid>

            {/* {website.organisation.enableCostCenter && user?.customer?.costCenters?.length &&
              <Grid item container xs={12}>
                <Grid item xs={12} style={{ margin: '40px 0 30px 0' }}>
                  <Typography variant="h4" align="center" style={{ fontWeight: 700 }} >
                    {t("root:selectCostCenter")}
                  </Typography>
                </Grid>
                <Grid item container xs={12} spacing={2}>
                  <Grid item xs={4}>
                    <div className={styles.dropdownWrap}>
                      <StyledInput
                        select
                        fullWidth
                        label={`Cost Center`}
                        name={"costCenter"}
                        variant="outlined"
                        onChange={(e) => {
                          setCostCenter(e.target.value)
                          setAvailableProjectIds(user?.customer?.costCenters?.find(cc => cc.name === e.target.value)?.projectIds || [])
                        }}
                      >
                        {user?.customer?.costCenters && user.customer.costCenters.map((cc) => (
                          <MenuItem key={cc.name} value={cc.name}>
                            {cc.name}
                          </MenuItem>
                        ))}
                      </StyledInput>
                    </div>
                  </Grid>
                  {availableProjectIds?.length > 0 && <Grid item xs={4}>
                    <div className={styles.dropdownWrap}>
                      <StyledInput
                        select
                        fullWidth
                        label={`Project Id`}
                        name={"projectId"}
                        variant="outlined"
                        onChange={(e: any) => {
                          setProjectId(e.target.value)
                        }}
                      >
                        {availableProjectIds.map((pid) => (
                          <MenuItem key={pid} value={pid}>
                            {pid}
                          </MenuItem>
                        ))}
                      </StyledInput>
                    </div>
                  </Grid>}
                </Grid>
              </Grid>
            } */}

            <Grid item container xs={12}>
              {(mergedPreBookingQuestions && mergedPreBookingQuestions?.length) ? <Grid item xs={12} style={{ margin: '40px 0 30px 0' }}>
                <Typography variant="h4" align="center" style={{ fontWeight: 700 }} >{t("root:additionalInformation")}</Typography>
              </Grid> : null}
              <Grid item xs={12}>
                {(mergedPreBookingQuestions && mergedPreBookingQuestions?.length) ? mergedPreBookingQuestions.map((bookingQuestion, idx) => {
                  switch (bookingQuestion.answerType) {
                    case ANSWER_TYPES.CHECKBOX:
                      return (
                        <Field name={`preBookingQuestions[${idx}].answer`} validate={(value: any) => validateAnswer(value, bookingQuestion.required, 'TRUE')} >
                          {({ field, meta: { touched, error }, }: FieldProps) => (
                            <div className={`${styles.validation} ${(touched && Boolean(error)) ? styles.error : ''}`}>
                              <FormControlLabel
                                control={
                                  <ColoredCheckbox
                                    {...field}
                                    checked={field.value}
                                    size="small"
                                    color="primary"
                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                    disabled={bookingQuestion.deleted}
                                  />
                                }
                                label={`${bookingQuestion.question} ${bookingQuestion.required ? "*" : ""}`}
                              />
                              {touched && Boolean(error) && <Typography variant="body1" style={{ color: '#D13135' }}>{bookingQuestion.errorMessage}</Typography>}
                            </div>
                          )}
                        </Field>
                      )
                      break;

                    case ANSWER_TYPES.DROP_DOWN:
                      return (
                        <Field name={`preBookingQuestions[${idx}].answer`} validate={(value: any) => validateAnswer(value, bookingQuestion.required, "TEXT")}>
                          {({ field, meta: { touched, error }, }: FieldProps) => (
                            <>
                              <div className={`${styles.bookingQuestion} ${touched && (Boolean(error)) ? styles.error : ''}`}>
                                <div className={styles.rowFlex}>
                                  <div style={{ display: 'flex', flex: 1, paddingRight: 15 }}>
                                    <Typography>{`${bookingQuestion.question} ${bookingQuestion.required ? "*" : ""}`}</Typography>
                                  </div>
                                  <div className={styles.dropdownWrap}>
                                    <StyledInput
                                      select
                                      {...field}
                                      fullWidth
                                      variant="outlined"
                                      // input={<StyledInputBase />}
                                      error={touched && Boolean(error)}
                                      disabled={bookingQuestion.deleted}
                                    >
                                      {bookingQuestion.options && bookingQuestion.options.map((option) => (
                                        <MenuItem key={option} value={option}>
                                          {option}
                                        </MenuItem>
                                      ))}
                                    </StyledInput>
                                  </div>
                                </div>
                                {touched && Boolean(error) && <Typography variant="body1" style={{ color: '#D13135' }}>{bookingQuestion.errorMessage}</Typography>}
                              </div>
                            </>
                          )}
                        </Field>
                      )
                      break;

                    case ANSWER_TYPES.YES_NO:
                      return (

                        <Field name={`preBookingQuestions[${idx}].answer`} validate={(value: any) => validateAnswer(value, bookingQuestion.required, bookingQuestion.expectedAnswer)}>
                          {({ field, meta: { touched, error }, }: FieldProps) => (
                            <RadioGroup {...field} onClick={field.onBlur} >
                              <div className={`${styles.bookingQuestion} ${touched && (Boolean(error)) ? styles.error : ''}`}>
                                <div className={styles.rowFlex}>
                                  <div style={{ display: 'flex', flex: 1, paddingRight: 15 }}>
                                    <Typography>{`${bookingQuestion.question} ${bookingQuestion.required ? "*" : ""}`}</Typography>
                                  </div>
                                  <div className={styles.yesnoWrap}>
                                    <Radio value="YES" id={`yes_no_${idx}_yes`} style={{ display: 'none' }} disabled={bookingQuestion.deleted} />
                                    <label htmlFor={`yes_no_${idx}_yes`} className={`${styles.yesnoButton} ${styles.left} ${field.value === "YES" ? styles.active : ''} ${bookingQuestion.deleted ? styles.disabled : ''}`}>{t("misc:yes")}</label>
                                    <Radio value="NO" id={`yes_no_${idx}_no`} style={{ display: 'none' }} disabled={bookingQuestion.deleted} />
                                    <label htmlFor={`yes_no_${idx}_no`} className={`${styles.yesnoButton} ${styles.right} ${field.value === "NO" ? styles.active : ''} ${bookingQuestion.deleted ? styles.disabled : ''}`}>{t("misc:no")}</label>
                                  </div>
                                </div>
                                {touched && Boolean(error) && <Typography variant="body1" style={{ color: '#D13135' }}>{bookingQuestion.errorMessage}</Typography>}
                              </div>
                            </RadioGroup>
                          )
                          }
                        </Field>
                      )
                      break;
                  }
                }) : null}
                {(mergedPreBookingQuestions && mergedPreBookingQuestions?.length) ? mergedPreBookingQuestions.map((bookingQuestion, idx) => {
                  switch (bookingQuestion.answerType) {
                    case ANSWER_TYPES.TEXT:
                      return (
                        <Field name={`preBookingQuestions[${idx}].answer`} validate={(value: any) => validateAnswer(value, bookingQuestion.required, 'TEXT')}>
                          {({ field, meta: { touched, error }, }: FieldProps) => (
                            <>
                              <Typography variant="body1"> {`${bookingQuestion.question} ${bookingQuestion.required ? "*" : ""}`}</Typography>
                              <StyledInput
                                variant="outlined"
                                {...field}
                                multiline
                                fullWidth
                                error={touched && Boolean(error)}
                                disabled={bookingQuestion.deleted}
                              />
                              <Typography variant="body1" style={{ color: '#D13135', padding: '5px 15px 5px 15px' }}>{touched && Boolean(error) && bookingQuestion.errorMessage}</Typography>
                            </>
                          )}
                        </Field>
                      )
                      break;
                  }
                }) : null}
                <Field name={`customerNote`} >
                  {({ field, meta: { touched, error }, }: FieldProps) => (
                    <>
                      <StyledInput
                        variant="outlined"
                        label={`${getLocalizedBookingSyntex(country)} ${t("root:note")}`}
                        {...field}
                        multiline
                        fullWidth
                        error={touched && Boolean(error)}
                        style={{ margin: '40px 0 30px 0' }}
                      />
                    </>
                  )}
                </Field>
                {
                  isSubscriptionBooking && (
                    <>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={enableDeliveryAddress}
                            name="enableDeliveryAddress"
                            onChange={(e) => {
                              setEnableDeliveryAddress(e.target.checked);
                              formikProps.setFieldValue("enableDeliveryAddress", e.target.checked)
                            }}
                            color="primary"
                          />
                        }
                        label={t("root:wantDelivered")}
                      />
                      {enableDeliveryAddress && (
                        <AddressPicker
                          fieldName={"deliveryAddress"}
                          label={t("root:deliveryAddress")}
                          onChange={(address) => {
                            if(!address?.geometry) {
                              setSelectedDeliverySlot({
                                startTime: "",
                                endTime: "",
                                driverId: ""
                              })
                            }
                            if (address) {

                              const clonedAddress: any = _.cloneDeep(address);
                              if (clonedAddress.geometry) {
                                clonedAddress.location = { ...clonedAddress.geometry };
                                delete clonedAddress.geometry;
                              }
                              formikProps.setFieldValue("deliveryAddress", clonedAddress)
                              const currentServiceLocation = branch?.locations.find(
                                (location) => location.id === props.bookingData?.pickupServiceLocation,
                              )
                              if(clonedAddress?.location) {
                                getAvailableDriverSlots({
                                  variables: {
                                    driverAvailableSlotArgs: {
                                      bookingCategory: props.bookingData?.isSubscription ? BOOKING_CATEGORY.SUBSCRIPTION : props.bookingData.bookingCategory,
                                      jobDate: props.bookingData.pickupDateTime,
                                      pickupCoordinate: {
                                        lat: currentServiceLocation?.address?.geometry?.latitude,
                                        lng: currentServiceLocation?.address?.geometry?.longitude,
                                      },
                                      dropOffCoordinate: {
                                        lat: clonedAddress?.location.latitude,
                                        lng: clonedAddress?.location.longitude,
                                      },
                                    },
                                    branchId: props.bookingData ? props.bookingData.branchId : "",
                                  }
                                })
                              }
                            }
                          }}
                          addGeometry={true}
                        />
                      )}
                      {logisticsEnabled && enableDeliveryAddress && formikProps.values.deliveryAddress.fullAddress && (
                        <Grid item xs={12} style={{ marginTop: "20px" }}>
                          <Typography variant="h6">{t("root:selectDeliverySlot")}</Typography>
                          <Grid style={{ marginTop: "10px" }}>
                            {
                              availableDriverSlots?.map((slot, index) => (
                                <Button
                                  key={`delivery-${index}`}
                                  variant={selectedDeliverySlot?.startTime === slot.startTime ? "contained" : "outlined"}
                                  color={selectedDeliverySlot?.startTime === slot.startTime ? "primary" : "inherit"}
                                  onClick={() => handleSlotSelection(slot, "delivery")}
                                  style={{ minWidth: "100px", marginRight: 15, marginBottom: 15 }}
                                  disabled={isSlotDisabled(slot, props.bookingData.pickupDateTime)}
                                >
                                  {slot.startTime}
                                </Button>
                              ))
                            }
                          </Grid>
                          {!availableDriverSlots?.length && (
                            <Typography variant="body2" style={{ marginTop: "10px", color: "#666" }}>
                              {t("root:note")} : {t("root:driverNotAvailable")}.
                            </Typography>
                          )}
                        </Grid>
                      )}
                    </>

                  )
                }
                <Field name="agreeToTerms" validate={(value: any) => validateAnswer(value, true, 'TRUE')}>
                  {({ field, meta: { touched, error }, }: FieldProps) => (
                    <div className={`${(touched && Boolean(error)) ? styles.error : ''}`} style={{ marginTop: 40, marginLeft: 3 }}>
                      <FormControlLabel
                        control={
                          <ColoredCheckbox
                            {...field}
                            size="small"
                            color="primary"
                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                          />
                        }
                        label={t("root:agreeWithTermsAndConditions")}
                      />
                      <a rel="noreferrer" target="_blank" className={styles.footerUrl} href={website.termsAndConditionsURL}>
                        <div>
                          <Hidden smDown><span style={{ paddingRight: 5 }}>{t("root:termsAndConditions")}</span></Hidden>
                          <LaunchIcon style={{ fontSize: 16 }} />
                        </div>
                      </a>
                      {(touched && Boolean(error)) && <Typography variant="body1" style={{ color: '#D13135' }}>{t("validation:termsConditionsAccepted")}</Typography>}
                    </div>
                  )}
                </Field>
              </Grid>
            </Grid>
            <Grid container item xs={12} justify="flex-end">
              {
                props.isLastStepPersonalDetails ? (
                  <Grid item >
                    <Button
                      className={styles.next_step_btn}
                      fullWidth
                      type="submit"
                    >
                      {t('root:continue')}
                    </Button>
                  </Grid>
                ) : (
                  <Grid item>
                    <Button
                      className={styles.next_step_btn}
                      type="submit"
                      fullWidth
                    >
                      {t("root:continue")}
                    </Button>
                  </Grid>
                )
              }
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default SimpleCustomerView;